import { CollapseProps, Descriptions, Flex, Grid, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Title from 'antd/es/typography/Title';
import { Fragment, useContext } from 'react';
import CollapseCustom from 'src/components/v2/Collapse';
import PriorityLevelTag from 'src/components/v2/Tag/PriorityLevelTag';
import { TicketDetailContext } from 'src/contexts/ticketDetail.context';
import { IManpowerSupplyForm, IManpowerSupplyFormDetail } from 'src/types/helpdesk/manpowerSupplyForm.type';
import './form.scss';
import { formatDate, formatTimeString } from 'src/utils/utils';

const { Text } = Typography;

const columns = function (): ColumnsType<IManpowerSupplyFormDetail> {
  return [
    {
      title: 'Công việc',
      dataIndex: 'job',
      key: 'job',
      width: '30%',
      render: (value: string, record: IManpowerSupplyFormDetail) => (
        <Flex vertical gap={10}>
          <Text>
            Tên công việc: <Text strong>{record.jobTitle}</Text>
          </Text>
          <Text>
            Chi tiết công việc: <Text strong>{record.jobDetail}</Text>
          </Text>
          <Text>
            Yêu cầu đặc thù: <Text strong>{record.jobRequirement}</Text>
          </Text>
        </Flex>
      )
    },
    {
      title: 'Ngày/giờ thực hiện',
      dataIndex: '',
      key: 'date',
      width: '20%',
      align: 'center',
      render: (record: IManpowerSupplyFormDetail) => (
        <Flex vertical gap={5}>
          <Text strong>
            {formatDate(record.fromDate)} - {formatDate(record.toDate)}
          </Text>
          <Text>
            {formatTimeString(record.startTime, true)} - {formatTimeString(record.endTime)}
          </Text>
        </Flex>
      )
    },
    {
      title: 'SL nhân lực',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
      width: '10%'
    },
    {
      title: 'Nơi làm việc',
      dataIndex: '',
      width: '10%',
      key: 'workingAt',
      align: 'center',
      render: (record: IManpowerSupplyFormDetail) => <Text>{record.workingAt?.name}</Text>
    }
  ];
};

const manpowerSupplyItems = (manpowerSupplys: IManpowerSupplyForm[], colspan: number): CollapseProps['items'] => {
  return manpowerSupplys.map((item) => ({
    key: item.id,
    label: (
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        key={item.id}
      >
        <Descriptions.Item label='ID cung ứng'>
          <Text strong>{item.id}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Cấp độ ưu tiên'>
          <PriorityLevelTag priorityLevel={item.priorityLevel} />
        </Descriptions.Item>
        <Descriptions.Item label='Mã dự án' span={colspan}>
          {item.projectCode ?? ''}
        </Descriptions.Item>
        {item.fromDate && item.toDate && (
          <Descriptions.Item label='Ngày' span={colspan}>
            <Text>{`${formatDate(item.fromDate)} - ${formatDate(item.toDate)}`}</Text>
          </Descriptions.Item>
        )}
        {item.quantity && (
          <Descriptions.Item label='Số nhân lực' span={colspan}>
            <Text>{item.quantity}</Text>
          </Descriptions.Item>
        )}
      </Descriptions>
    ),
    children: (
      <Fragment>
        <Title level={5} style={{ marginBlock: '10px' }}>
          Thông tin chi tiết cung ứng nhân lực:
        </Title>
        <Table
          className='manpower-supply-form-table'
          columns={columns()}
          rowKey={(record) => String(record.id)}
          dataSource={item?.details}
          pagination={false}
          scroll={{ x: 400 }}
          bordered={false}
          size='small'
        />
        <Title level={5} style={{ marginBlock: '10px' }}>
          Thông tin liên hệ thực hiện công việc:
        </Title>
        <Descriptions labelStyle={{ width: '135px' }} column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}>
          <Descriptions.Item label='Người liên hệ'>{item.contactPerson ?? ''}</Descriptions.Item>
          <Descriptions.Item label='Tên công ty'>{item.companyName ?? ''}</Descriptions.Item>
          <Descriptions.Item label='Chức vụ'>{item.position ?? ''}</Descriptions.Item>
          <Descriptions.Item label='Số điện thoại'>{item.phone ?? ''}</Descriptions.Item>
          <Descriptions.Item label='Địa chỉ làm việc' span={colspan}>
            {item?.workplaceAddressFull}
          </Descriptions.Item>
          <Descriptions.Item label='Ghi chú' span={colspan}>
            {item.note ?? ''}
          </Descriptions.Item>
        </Descriptions>
      </Fragment>
    )
  }));
};

const ManpowerSupplyForm = (): JSX.Element => {
  const { ticket } = useContext(TicketDetailContext);
  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  return (
    <CollapseCustom
      isFullDefault
      titleLevel={5}
      title='Danh sách thông tin cung ứng nhân lực'
      ghost
      isSegmented={true}
      items={manpowerSupplyItems(ticket?.data.manpowerSupplyForms || [], colspan)}
      expandIconPosition='end'
      className='manpower-supply-collapse'
    />
  );
};
export default ManpowerSupplyForm;
